import { clickToCopy } from './modules/clipboard.ts';
import { $$ } from './modules/dom.ts';

const divs = $$('.copyable');

divs.forEach((div: Element) => {
  div.addEventListener('click', (e) => {
    const span = e.target as HTMLElement;
    span.classList.add('is-animating');
    span.addEventListener(
      'animationend',
      () => {
        span.classList.remove('is-animating');
      },
      { once: true },
    );
  });
});

clickToCopy('.copyable');
